<template>
  <CContainer fluid>
    <h3>Productos en Campaña</h3>
    <CCard class="mb-4">
      <CCardBody>
        <CRow>
          <CCol col="sm-6" sm="6">
            <CInput 
              label="Buscar:" 
              :value.sync="searchWord" 
              @keyup.enter="getData(1, searchWord)">
              <template #prepend-content>
                <a href="#" @click="getData(1)">
                  <i class="bi bi-arrow-clockwise"></i>
                </a>
              </template>
              <template #append-content>
                <a href="#" @click="getData(1, searchWord)">
                  <i class="bi bi-search"></i>
                </a>
              </template>
            </CInput>
          </CCol>
          <CCol col="sm-6" sm="6">
            <CButton 
              color="dark" 
              class="mt-4" 
              to="/administracion/mercadeo/campanias">
              <CIcon name="cil-ChevronCircleLeftAlt" />
              <span class="p-2 align-middle">Regresar</span>
            </CButton>
            <!-- <CButton 
              color="success" 
              class="mt-4" 
              @click="goTo({}, 'agregar')">
              <CIcon name="cil-plus" />
              <span class="p-2 align-middle">Agregar</span>
            </CButton> -->
          </CCol>
        </CRow>
        <CDataTable
          hover
          :items="CampaignsProducts"
          :fields="fields"
          :items-per-page="itemsPerPage"
          :loading="loading">
          <template #producto="{ item }">
            <td>
              <h4>{{ item.descripcion }}</h4>
              <div>
                <span>{{ item.codigo }}</span>
              </div>
            </td>
          </template>
          <template #info="{ item }">
            <td>
              <div>
                <span>Fecha Inicial: {{ moment(item.fecha_Inicial).format('DD/MM/YYYY') }}</span>
              </div>
              <div>
                <span>Fecha Final: {{ moment(item.fecha_Final).format('DD/MM/YYYY') }}</span>
              </div>
            </td>
          </template>
        </CDataTable>
      </CCardBody>

      <CElementCover v-show="loading" /> 
    </CCard>
  </CContainer>
</template>
<script>
  const fields = [
    { 
      key: "producto", 
      label: "Producto", 
      _style: "text-align: center;"
    },
    { 
      key: "info", 
      label: ""
    }
  ]
  export default {
    data() {
      return {
        fields,
        loading: false,
        page: 1,
        pageCount: 1,
        itemsPerPage: 5,
        searchWord: "",
        CampaignsProducts: []
      }
    },
  }
</script>